module.exports = __webpack_public_path__ + "img/课程完成率.d87e299d.png";